export default {
  'Sample photo': '示例圖片',
  Removing: '去除中',
  Edit: '編輯',
  'Adjust Picture': '圖片調整',
  Restore: '復原',
  Eraser: '橡皮',
  Size: '尺寸',
  Background: '背景',
  Custom: '常用',
  Presets: '預設',
  'Add Image': '添加圖片',
  'Scale to Fit': '縮放以合適',
  'Full Width': '全屏寬度',
  'Full Height': '全屏高度',
  Move: '移動',
  Undo: '撤銷',
  Redo: '恢復',
  Enlarge: '放大',
  Reduce: '縮小',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw 線上背景去除',
    desc: '輕鬆移除掉你的照片背景 100%自動和免費',
    imgAlt: 'photo background remover',
    submitBtn: '去除背景',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
      "Upload failed, click to try again": "Upload failed, click to try again",
};
